import FingerprintJS from '@fingerprintjs/fingerprintjs-pro';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { enPaymentMethod } from 'enums/enPaymentMethod';
import { fromPromise } from 'rxjs/observable/fromPromise';
import { IS_DEVELOPMENT } from 'settings';
import { v4 } from 'uuid';
import { of } from 'rxjs/observable/of';
import { sleep } from '../functions';

class FingerprintService {
  private fingerprint$ = new BehaviorSubject<string>('');
  private creating = false;

  public getFingerprint(paymentMethod: enPaymentMethod) {
    const currentFingerprint = this.fingerprint$.value;

    let observable = this.fingerprint$.asObservable();

    const fingerprintPaymentAllowed = [enPaymentMethod.CREDIT_CARD, enPaymentMethod.PIX, enPaymentMethod.BANKSLIP];

    if (!currentFingerprint && fingerprintPaymentAllowed.includes(paymentMethod) && !IS_DEVELOPMENT) {
      this.createFingerprint();
      observable = this.fingerprint$.filter((fingerprint) => !!fingerprint);
    }

    return observable.take(1);
  }

  private async createFingerprint() {
    if (this.creating) {
      return;
    }

    this.creating = true;

    const fp = await FingerprintJS.load({
      token: 'tFK4Pj7hMYNOlrHYEW4s'
    });

    const generator = async () => {
      try {
        const result = await fp.get();
        return result.visitorId;
      } catch (err) {
        await sleep(2000);
        throw err;
      }
    };

    of(true)
      .switchMap(() => fromPromise(generator()))
      .retry(10)
      .catch(() => {
        this.creating = false;
        return of('failed-' + v4());
      })
      .subscribe((fp) => this.fingerprint$.next(fp));
  }
}

export const fingerprintService = new FingerprintService();
